// Separate display-only D.A.P counters before any operational statistics run.
// Keep the original documents/operations untouched, including historical data.
export function separateDashboardDap(documents, selectedDate, { countTrucks, groupFor }) {
  const dapCounts = Object.fromEntries(["fiscal1", "fiscal2", "nacional1", "nacional2"]
    .map((key) => [key, { ingresos: 0, egresos: 0 }]));
  const regularDocs = (Array.isArray(documents) ? documents : []).map((doc) => {
    const day = typeof doc.fecha === "string"
      ? doc.fecha.slice(0, 10)
      : new Date(doc.fecha || new Date()).toISOString().slice(0, 10);
    const operations = Array.isArray(doc.Operacion) ? doc.Operacion : [];
    return {
      ...doc,
      Operacion: operations.filter((op) => {
        if (op?.dap !== true) return true;
        if (day === selectedDate) {
          const group = dapCounts[groupFor(op, doc.deposito || "binder1")];
          if (group) {
            const count = countTrucks(op);
            if (op.tipo === "Ingreso") group.ingresos += count;
            else if (op.tipo === "Egreso") group.egresos += count;
          }
        }
        return false;
      }),
    };
  });
  return { regularDocs, dapCounts };
}
